import { BENEFITS } from "../../lib/data";
import { Reveal, Overline } from "./Reveal";
import { CheckCircle2 } from "lucide-react";

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 md:py-36 bg-sand-dark">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
        <Reveal className="lg:col-span-7">
          <Overline>What I do</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-light tracking-tight text-charcoal leading-tight">
            Tailored full-body equine sports massage
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-stone text-lg font-light leading-relaxed">
            One thorough treatment, designed around your horse. Each session combines evaluation, hands-on massage, and aftercare, working through the whole body to find and ease what's holding them back.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.07}>
            <div
              data-testid={`benefit-card-${i}`}
              className="h-full bg-sand rounded-3xl p-8 border border-charcoal/5 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-md"
            >
              <CheckCircle2 className="text-clay" strokeWidth={1.5} />
              <h3 className="mt-5 font-heading text-2xl text-charcoal">{b.title}</h3>
              <p className="mt-3 text-stone font-light leading-relaxed">{b.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
